export default __webpack_public_path__ + "static/media/disney.d94b93e6.png";